import { openWhatsAppLeadModal } from './getWhatsAppRedirectionUrl';

/**
 * common function to open whatsapp for messaging the store owner
 * display/registered number
 * @param {Object} - userData, phoneNumber, storeUrl
 */
export const whatsappMessageRender = () => {
  openWhatsAppLeadModal();
};
